import React, { useEffect, useState, FC, useRef } from "react";
import { Button } from "antd";
import { YhFormBox } from "@/components/YhFormBox";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, IYhFormRef } from "@/components/YhFormBox/Types";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { useVrmMaintenanceRoDetailsModel } from "../vrmBillMaintenanceRoModel";
export const FormBox: FC<RouterParamType> = () => {
    const formRef = useRef<IYhFormRef>();
    const {
        detailLookForm,
        resetLookCatch,
        getDetailEditOne,
    } = useVrmMaintenanceRoDetailsModel();
    const { selectedNavId, replaceNav, findNav, getSelectedNavState } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const { id, mode, parentInfo } = detailsInfo
    const [more, setMore] = useState<boolean>(true);  //控制更多按钮
    useEffect(() => {
        getDetailEditOne(id)
    }, [id])

    useEffect(() => {
        return () => {
            resetLookCatch();
        }
    }, [selectedNavId])

    const title = <>
        <span>基础信息</span>
    </>
    const baseFormItem: IYhFormItemsBox = {
        title: title,
        style: { padding: "18px 0 0 0", marginBottom: "15px" },
        contentClass: "pr-77",
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "退单单号",
                fieldName: "returnCode",
                disable: true,
                placeholder: "自动生成",
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: '客户名称',
                fieldName: "customerName",
                rules: [{ required: true, message: "请选择客户" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "送修人",
                fieldName: "contact",
                rules: [{ required: true, message: "请输入送修人" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "送车电话",
                fieldName: "phone",
                rules: [{ required: true, message: "请输入送车电话" }]
            },{
                type: FormItemTypeEnum.Select,
                fieldLabel: "维修类型",
                fieldName: "serviceNatureName",
                rules: [{ required: true, message: "请选择维修类型" }]
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "售价选择",
                fieldName: "priceTypeName",
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: '车辆牌照',
                fieldName: "licensePlate",
                rules: [{ required: true, message: "请输入车牌号" }]
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "VIN码",
                fieldName: "vin",
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "销售实体",
                fieldName: "bentityName",
                rules: [{ required: true, message: "请选择销售实体" }]

            },{
                type: FormItemTypeEnum.Input,
                fieldLabel: "结算方",
                fieldName: "settlementPartyName",
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "结算类型",
                fieldName: "payType",
                rules: [{ required: true, message: "请选择结算类型" }],
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "整单抹零",
                fieldName: "favorableAmount",
                span: 5,
                labelCol: { offset: 1 },
            }, {
                type: FormItemTypeEnum.Button,
                fieldLabel: <a className="color-blue text-line" onClick={() => setMore(!more)}>{more ? '更多>>' : "隐藏"}</a>,
                fieldName: "none",
                span: 1,
                labelCol: { offset: 5 },
            },{
                type: FormItemTypeEnum.Select,
                fieldLabel: "车辆类型",
                fieldName: "vehicleTypeName",
                hidden: more
            },   {
                type: FormItemTypeEnum.Input,
                fieldLabel: "车辆型号",
                fieldName: "vehicleModel",
                hidden: more
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "发票类型",
                fieldName: "invoiceTypeName",
                hidden: more,
            },{
                type: FormItemTypeEnum.Input,
                fieldLabel: "车辆里程",
                fieldName: "mileage",
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "工作小时",
                fieldName: "workingHours",
                hidden: more
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "进厂时间",
                showTime: true,
                fieldName: "enterTime",
                hidden: more
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "出厂时间",
                showTime: true,
                fieldName: "deliveryTime",
                hidden: more
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "服务地点",
                fieldName: "serviceLocationCode",
                hidden: more,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "所属门店",
                fieldName: "shopName",
                disable: true,
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "故障描述",
                fieldName: "faultDesc",
                hidden: more
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "处理意见",
                fieldName: "faultResult",
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户地址",
                fieldName: "customerAddress",
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "待修内容",
                fieldName: "toBeRepaired",
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "下次保养时间",
                fieldName: "nextMaintainTime",
                hidden: more
            },{
                type: FormItemTypeEnum.Input,
                fieldLabel: "财务备注",
                fieldName: "fmsNote",
                hidden: more
            },  {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
                hidden: more
            },
            //带出字段
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "销售实体名称",
                fieldName: "bentityName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户名称",
                fieldName: "customerName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "车辆类型Name",
                fieldName: "vehicleTypeName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "维修类型Name",
                fieldName: "maintenanceTypeName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "结算方Name",
                fieldName: "settlementPartyName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "结算方式Name",
                fieldName: "paymentMethodName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户类型Name",
                fieldName: "customerTypeName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "发票类型Name",
                fieldName: "invoiceTypeName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "服务类型Name",
                fieldName: "serviceNatureName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "服务地点Name",
                fieldName: "serviceLocationName",
                hidden: true
            },{
                type: FormItemTypeEnum.Input,
                fieldLabel: "售价选择Name",
                fieldName: "priceTypeName",
                hidden: true
            }
        ]
    };
    const poFromConfig: IYhFormBox = {
        formRef,
        disabled: true,
        labelCol: { span: 6 },
        labelAlign: "right",
        formValues: detailLookForm,
        boxs: [baseFormItem]
    }


    return (
        <YhFormBox {...poFromConfig} />
    )
}